// src/services/firebase/config.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCx4D6tdU2C7ijFNBnEVfJ6cM9h-nwKx0E",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "burotime-ed294.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "burotime-ed294",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "burotime-ed294.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "568811773259",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:568811773259:web:a279f85e7323592ab09cce",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-JZ8ZQM98EH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;